import React from 'react'
import { Home, Gamepad2, PlaySquare, User } from "lucide-react";
import { useNavigate, useLocation } from 'react-router-dom';
import { BASE_URL } from '../http/http';
import Cookies from 'js-cookie';
import axios from 'axios';
const TABnavigation = ({ navHandeler }) => {
  const navigate = useNavigate();
  const location = useLocation();
 
  const getColor = (route) => location.pathname === route ? '#3CB8D4' : 'white';

  return (
    <>
      <div className='flex justify-center items-center gap-10 h-16 w-full text-white py-10'>
        <Home
          size={32}
          color={getColor('/auth')}
          onClick={() => navigate('/auth')}
          style={{ cursor: 'pointer' }}
        />
        <Gamepad2
          size={32}
          color={location.pathname === '/game' ? '#3CB8D4' : 'white'}
          onClick={navHandeler}
          style={{ cursor: 'pointer' }}
        />
        <PlaySquare
          size={32}
          color={location.pathname === '/play' ? '#3CB8D4' : 'white'}
          onClick={navHandeler}
          style={{ cursor: 'pointer' }}
        />
        <User
          size={32}
          color={getColor('/profile')}
          onClick={() => navigate('/profile')}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </>
  );
};

export default TABnavigation;